import { sharedWearablesColumns } from "./sharedWearablesColumns"
import { InputCellRenderer } from "@/components/shared/Table/TextCellRenderer"
import { Column } from "@/components/shared/Table/types"
import { WearableSensor } from "@/types/wearableSensors"
import { getFullInmateInfo } from "@/utils/index"

export const wearablesJmsColumns: Column<WearableSensor>[] = [
   ...sharedWearablesColumns,
   {
      key: "inmate",
      label: "Inmate",
      sortable: true,
      renderCell: (args) =>
         InputCellRenderer<WearableSensor>({
            field: "inmate",
         })({
            ...args,
            value:
               args.row.inmate?.customIdentifier ||
               getFullInmateInfo(args.row.inmate),
         }),
   },
]
